import script from "./BaseMultiselectFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseMultiselectFilter.vue?vue&type=script&setup=true&lang=js"

import "./BaseMultiselectFilter.vue?vue&type=style&index=0&id=6b9cbfa2&lang=css"

const __exports__ = script;

export default __exports__